import { Splide } from '@splidejs/splide';
import '@splidejs/splide/css/core';

class StoriesSlides {
  constructor(el) {
    this.dom = {el: el};
    this.dom.slider = this.dom.el.querySelector('.splide');

    this.slider = null;
    this.option = {
      pagination: false,
      arrows: false,
      type   : 'slide',
      gap: `min(${10 / 16}rem, ${10 / 375 * 100}vw)`,
      padding: `min(${25 / 16}rem, ${25 / 375 * 100}vw)`,

      perPage: 1,
      speed: 900,
      arrows: true,
      mediaQuery: 'min',
      breakpoints: {
        768: {
          perPage: 2,
          gap: `min(${25 / 16}rem, ${25 / 1440 * 100}vw)`,
          padding: {
            left: `min(${172 / 16}rem, ${172 / 1440 * 100}vw)`,
            right: `min(${228 / 16}rem, ${228 / 1440 * 100}vw)`,
          },
        },
        1024: {
          perPage: 3,
        },
      }
    };

    this.init();
  }

  init() {
    this.slider = new Splide(this.dom.slider, this.option);
    this.dom.progress = this.slider.root.querySelector('.splide-carousel-progress-bar');
    // this.slider.on('mounted move', () => {
    //   const end  = this.slider.Components.Controller.getEnd() + 1;
    //   const rate = Math.min( ( this.slider.index + 1 ) / end, 1 );
    //   this.dom.progress.style.width = String( 100 * rate ) + '%';
    // } );
    this.slider.mount();
  }
}

export default StoriesSlides
